import { render, staticRenderFns } from "./FilterClear.vue?vue&type=template&id=2209d0a5"
import script from "./FilterClear.vue?vue&type=script&lang=ts"
export * from "./FilterClear.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports